module.exports = __webpack_public_path__ + "img/IMG_3505.11025092.jpg";